import React from "react";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import type { OperandDto } from "../../../../../../types/resolver";
import { CODES_CONTEXT_KEYS, CASE_CONTEXT_KEYS, SPAN_CONTEXT_KEYS } from "./constants";
import type { OperandTypeComponentProps } from "./types";
import type { EvaluationDomain } from "../../../../../../types/resolver";

export interface KeyOperandProps extends OperandTypeComponentProps {
    evaluationDomain?: EvaluationDomain;
}

export const KeyOperand: React.FC<KeyOperandProps> = ({
    value,
    onChange,
    evaluationDomain,
}) => {
    const keyOptions: readonly string[] =
        evaluationDomain === "CODES"
            ? CODES_CONTEXT_KEYS
            : evaluationDomain === "CASE"
              ? CASE_CONTEXT_KEYS
              : SPAN_CONTEXT_KEYS;

    const currentKey = value?.key ?? "";
    const displayKey = evaluationDomain && keyOptions.includes(currentKey)
        ? currentKey
        : (keyOptions[0] ?? "");

    if (evaluationDomain) {
        return (
            <FormControl size="small" fullWidth>
                <InputLabel id="key-context-label">Key (context path)</InputLabel>
                <Select
                    labelId="key-context-label"
                    label="Key (context path)"
                    value={displayKey}
                    onChange={(e) => {
                        const v = e.target.value as string;
                        onChange({
                            ...(value ?? {}),
                            operandType: "key",
                            key: v,
                        } as OperandDto);
                    }}
                >
                    {keyOptions.map((k) => (
                        <MenuItem key={k} value={k}>
                            {k}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }

    return (
        <TextField
            size="small"
            label="Key (path)"
            value={String(value?.key ?? "")}
            onChange={(e) =>
                onChange({
                    ...(value ?? {}),
                    operandType: "key",
                    key: e.target.value,
                } as OperandDto)
            }
            placeholder="e.g. code, codeType"
            fullWidth
        />
    );
};
